import { render } from "./freeAuthService.vue?vue&type=template&id=5f5ca6e6&scoped=true&ts=true"
import script from "./freeAuthService.vue?vue&type=script&lang=ts"
export * from "./freeAuthService.vue?vue&type=script&lang=ts"

import "./freeAuthService.vue?vue&type=style&index=0&id=5f5ca6e6&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5ca6e6"]])

export default __exports__